import { and, isLayout, JsonFormsRendererRegistryEntry, rankWith, uiTypeIs } from '@jsonforms/core';
import layoutRenderer from './GroupLayoutRenderer.vue';

export const entry: JsonFormsRendererRegistryEntry = {
  renderer: layoutRenderer,
  tester: rankWith(2, and(isLayout, uiTypeIs('Group'))),
};
